import * as React from "react";
import Input from "../Input-new/Input";
import SelectFirm from "../SelectFirm/SelectFirm";
import Checkbox from "../HotListCheckbox";
import { can } from "../../access";
import OpenInCrmButton from "../OpenInCrmButton/OpenInCrmButton";

const AgentInfo = ({
  data,
  handleChangeInput,
  handleChangeDropdown,
  viewMode,
  deleted,
  hscOptions
}) => {
  const hasLeadId = Boolean(data.LEAD_ID);

  return (
    <div className="Agent-info">
      <div className="Agent-info_column">
      <div className="hotlist_name_section">
        <div className="Agent-info_column_hotlist_name_label">
            <label>First Name</label>
            <Checkbox 
                text="Hot List"
                type={viewMode || !can('peak.pipeline') ? "uncheckable" : "checkable"}
                isSelected={data.HSC_HOT_LIST === "1"} 
                handleClick={() => handleChangeInput("HSC_HOT_LIST")} 
                name="HSC_HOT_LIST"
            />

        </div>
        <Input
            className="Agent-info_column_item"
            required
            valueType="text"
            name="FIRST_NAME"
            value={data.FIRST_NAME}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />
        </div>

            
     
        <Input
          className="Agent-info_column_item"
          required
          valueType="text"
          name="LAST_NAME"
          label="Last Name"
          value={data.LAST_NAME}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Agent-info_column_item"
          valueType="phone"
          name="PHONE"
          label="Work Phone"
          value={data.PHONE}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
            className="Agent-info_column_item"
            valueType="phone"
            name="CELL_PHONE"
            label="Cell Phone"
            value={data.CELL_PHONE}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />
        <Input
          className="Agent-info_column_item"
          valueType="email"
          name="EMAIL"
          label="Email"
          value={data.EMAIL}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <SelectFirm
          className="Agent-info_column_item"
          value={data.FIRM}
          valueKey="FIRM"
          label="Firm"
          data={data}
          handleParentChange={handleChangeDropdown}
          viewMode={viewMode}
          deleted={deleted}
          searchAddress
          canAddFirm
        />
        <Input
          className="Agent-info_column_item"
          valueType="text"
          name="LEAD_ID"
          label="Lead ID"
          value={data.LEAD_ID}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        {hasLeadId && (
          <div style={{
            marginTop: '12px',
            padding: '12px 16px',
            backgroundColor: '#e8f5e9',
            borderRadius: '8px',
            border: '1px solid #c8e6c9'
          }}>
            <OpenInCrmButton leadId={data.LEAD_ID} entityType="vendor" />
          </div>
        )}
      </div>
    </div>
  );
};

export default AgentInfo;
